import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelAppointment,
  getUpcomingAppointments,
  rescheduleAppointment,
} from "../../Redux/Slice/Upcomming";
import { useSnackbar } from "notistack";

const UpcomingAppointments = () => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [rescheduleData, setRescheduleData] = useState({ date: "", time: "" });
  const { enqueueSnackbar } = useSnackbar();

  const { items } = useSelector((state) => state.upcomingAppointments);
  const appointments = items?.data || [];

  useEffect(() => {
    dispatch(getUpcomingAppointments());
  }, [dispatch]);
  const handleCancel = (appointmentId) => {
    if (window.confirm("Are you sure you want to cancel this appointment?")) {
      const reason = prompt("Please enter a reason for cancellation:");
      if (!reason) {
        enqueueSnackbar("Cancellation reason is required.", {
          variant: "warning",
        });
        return;
      }

      dispatch(cancelAppointment({ appointmentId, cancellationReason: reason }))
        .unwrap()
        .then((res) => {
          if (res.status) {
            enqueueSnackbar("Appointment cancelled successfully.", {
              variant: "success",
            });
            dispatch(getUpcomingAppointments());
          } else {
            enqueueSnackbar(res.message || "Cancellation failed.", {
              variant: "error",
            });
          }
        })
        .catch((err) => {
          enqueueSnackbar(err.message || "Something went wrong.", {
            variant: "error",
          });
        });
    }
  };

  const handleOpenReschedule = (appt) => {
    setEditingId(appt.appointmentId);
    setRescheduleData({
      date: appt.appointmentDate,
      time: appt.appointmentTime,
    });
    setOpenDialog(true);
  };

  const handleRescheduleSubmit = () => {
    dispatch(
      rescheduleAppointment({
        appointmentId: editingId,
        newDate: rescheduleData.date,
        newTime: rescheduleData.time,
      })
    )
      .unwrap()
      .then((res) => {
        if (res.status) {
          enqueueSnackbar("Appointment rescheduled successfully!", {
            variant: "success",
          });
          setOpenDialog(false);
          setEditingId(null);
          dispatch(getUpcomingAppointments());
        } else {
          enqueueSnackbar(res.message || "Rescheduling failed.", {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message || "Something went wrong.", {
          variant: "error",
        });
      });
  };

  return (
    <Box sx={{ padding: "2rem" }}>
      <Typography variant="h6" mb={4}>
        Upcoming Appointments
      </Typography>

      {appointments.length === 0 ? (
        <Typography color="text.secondary">
          No upcoming appointments.
        </Typography>
      ) : (
        appointments.map((appt) => (
          <Paper
            key={appt.appointmentId}
            elevation={2}
            sx={{
              p: 2,
              mb: 2,
              borderLeft: "6px solid #1976d2",
              backgroundColor: "#f5f8ff",
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              {appt.doctorName}{" "}
              <span style={{ fontWeight: 400 }}>
                ({appt.department || "Department"})
              </span>
            </Typography>
            <Typography>
              <strong>Appointment For:</strong> {appt.patientName}
            </Typography>
            <Typography>
              <strong>Date:</strong> {appt.appointmentDate} |{" "}
              <strong>Time:</strong>{" "}
              {appt.appointmentTime?.slice(0, 5) || "--:--"}
            </Typography>

            <Box mt={1} display="flex" gap={1}>
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleCancel(appt.appointmentId)}
                size="small"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => handleOpenReschedule(appt)}
                size="small"
              >
                Reschedule
              </Button>
            </Box>
          </Paper>
        ))
      )}

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Reschedule Appointment</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="New Date"
              type="date"
              fullWidth
              value={rescheduleData.date}
              onChange={(e) =>
                setRescheduleData({ ...rescheduleData, date: e.target.value })
              }
              InputLabelProps={{ shrink: true }}
              size="small"
            />
            <TextField
              label="New Time"
              type="time"
              fullWidth
              value={rescheduleData.time}
              onChange={(e) =>
                setRescheduleData({ ...rescheduleData, time: e.target.value })
              }
              InputLabelProps={{ shrink: true }}
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleRescheduleSubmit}>
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UpcomingAppointments;
